import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ToastrModule } from "ngx-toastr";
import { TagInputModule } from "ngx-chips";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { QRCodeComponent } from 'angularx-qrcode';

import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";

import { BrowserModule } from "@angular/platform-browser";
import { ComponentsModule } from "./components/components.module";

import { AppRoutingModule } from "./app-routing.module";

@NgModule({ declarations: [AppComponent, AdminLayoutComponent, AuthLayoutComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        FormsModule,
        RouterModule,
        ComponentsModule,
        BsDropdownModule.forRoot(),
        AppRoutingModule,
        ToastrModule.forRoot(),
        CollapseModule.forRoot(),
        TagInputModule,
        BrowserModule,
        ReactiveFormsModule,
        QRCodeComponent], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
